export enum AuthRoutePathsEnum {
  LOGIN = 'login',
  PASSWORDLESS_LOGIN = 'passwordless-login',
  PASSWORDLESS_LOGIN_ERROR = 'passwordless-login-error',
  TELEKOM = 'telekom',
}
